
const settings = {
    title: "My PetSite",
    profile: "profile.webp",
    slogan: "We're the best in class",
};

export default settings;